require('../css/main.scss') //css entry for dev - will be removed automagically for production version

//default js dependencies
import "./plugins/fastclick"
import objectFitImages from 'object-fit-images'


import EE from './helpers/ee'
import { panelHandlers } from './panel/panel'

import noScroll from 'no-scroll'

import $ from 'jquery'

import './forms/contactForm'
import './forms/dynamicForm'

panelHandlers()


EE.on('no-scroll-on', function(){
  console.info('noscroll on');
  noScroll.on();
})
EE.on('no-scroll-off', function(){
  console.info('noscroll off');
  noScroll.off();
})

EE.emit('event-name')


//additional js dependencies
// import "./plugins/mmenu"
// import "./plugins/validate"
// import "./plugins/gsap"

objectFitImages('img', { watchMQ: true })

import "./modal/modal"
import "./slider/siema"
import "./accordian/accordian"


$(function () {
  $('a[href*="#"]:not([href="#"],[href*="#mm-"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 0
        }, 400);
        return false;
      }
    }
  });
});


// WEBPACK FOOTER //
// ./assets/js/main.js